module.exports = __webpack_public_path__ + "img/pending_mute.b4827ff5.png";